import request from '@/utils/request'

export function bindEmailApi(data) {
  return request({
    url: '/user/bindEmail',
    method: 'post',
    data
  })
}
